<div class="auth-full-height d-flex flex-row align-items-center">
    <div class="container">
       <div class="row justify-content-center">
           <div class="col-md-4">
                <div class="card">
                    <div class="card-body">
                        <div class="m-2">
                            <div class="d-flex justify-content-center mt-3">
                                <img style="max-width:300px;width: 100%;" src="/assets/images/Logo-01.png" alt="">
                                <!-- <logo class="text-center" logoType="fold"></logo> -->
                            </div>
                            <div class="text-center mt-3">
                                <h3 class="fw-bolder">Sign In</h3>
                                <p class="text-muted">Sign in your account to continue</p>
                            </div>
                            <login-form></login-form>
                            <div class="text-center mt-4">
                                <p class="text-muted">Don't have an account yet? <a href="/register">Sign Up</a></p>
                            </div>
                        </div>
                    </div>
                </div>
           </div>
       </div> 
    </div>
</div>